import _ from 'lodash'

const isReady = (state) => !_.isUndefined(state.ready)
const isShowAlert = (state) => _.get(state, 'isShowAlert')
const alertMessage = (state) => _.get(state, 'alertMessage')
const alertType = (state) => _.get(state, 'alertType')
const closeTimeout = (state) => _.get(state, 'closeTimeout')
const sessionId = (state) => _.get(state, 'session_id')
const search = (state) => _.get(state, 'search')
const cachedPageFilters = (state) => _.get(state, 'cachedPageFilters')
const sortLists = (state) => _.get(state, 'sortList')
const sortLoading = (state) => _.get(state, 'sortLoading')

const pageTitle = (state) => _.get(state, 'pageTitle')
const hasOtherProfileAccess = (state) => _.get(state, 'hasOtherProfileAccess')

export default {
	isReady,
	isShowAlert,
	alertMessage,
	alertType,
	closeTimeout,
	sessionId,
	search,
	cachedPageFilters,
	sortLists,
	sortLoading,
	pageTitle,
	hasOtherProfileAccess
}
